<template src="./header.html">
</template>
<script>
  import Vue from 'vue'
  import Login from './login/Login.vue'
  import { logout, isAuth } from '@/router/auth'
  import { getUser } from '@/utils/cookie'
  import { EventBus } from '@/router/bus'
  import AlertContainer from './alert-container/AlertContainer.vue'
  import NotificationContainer from './notification-container/NotificationContainer.vue'

  export default {
    name: 'header',
    data () {
      return {
        environment: process.env.NODE_ENV,
        isAuth: false,
        username: '',
        externalLinks: [],
        registrationAllowed: Vue.$config.registration_allowed
      }
    },
    computed: {
      headerClass () {
        return 'header-' + this.environment.toLowerCase()
      },
      isDevelopment () {
        return !this.isProductionEnvironment()
      },
      documentationPath () {
        return Vue.$config.help_root
      }
    },
    methods: {
      logout: function () {
        this.logConsole('Logging out')

        EventBus.$emit('notification-close')
        this.userIsLoggedOut()
        logout()
        this.$router.push('/')
      },
      userIsLoggedIn () {
        this.isAuth = isAuth()
        this.username = getUser()
      },
      userIsLoggedOut () {
        this.isAuth = false
        this.username = ''
      },
      isStaging () {
        return true
      },
      isDevel () {
        return false
      }
    },
    components: {
      Login,
      AlertContainer,
      NotificationContainer
    },
    created () {
      this.userIsLoggedIn()
      EventBus.$on('logged-in', () => {
        this.userIsLoggedIn()
      })
      EventBus.$on('logged-out', () => {
        this.userIsLoggedOut()
      })

      this.externalLinks = Vue.$config.external_links
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>
    @import '~@/assets/scss/variables.scss';
    
    header {
        font-size: 12pt;
        position: relative;
        min-height: $header-height;
        background-color: $primary-color;

        .header-username-link {
            font-weight: bold;
            color: transparentize($font-color-light, .1);                
        }
    }

    .header-development {
      background-color: $primary-color-devel !important;
    }

    .header-staging {
      background-color: $background-color-warning !important;
    }

    .header-production {
      background-color: $primary-color !important;
    }

    .header-ptest {
      background-color: $primary-color-ptest !important;
    }

    .heavier-text {
        font-weight: 600;
    }

</style>



// WEBPACK FOOTER //
// Header.vue?280b24fc